// extracted by mini-css-extract-plugin
export var jamstack = "jamstack-website-module--jamstack--2zQYq";
export var jamstackHero = "jamstack-website-module--jamstackHero--1_b0k";
export var benefits = "jamstack-website-module--benefits--2zeQD";
export var benefit = "jamstack-website-module--benefit--twl6e";
export var otherServices = "jamstack-website-module--otherServices--1Xyuu";
export var highlightedSection = "jamstack-website-module--highlightedSection--2C9yF";